const typeRequest = [
  { value: 0, label: "Básica", ENUM: "BASIC_REGISTER" },
  { value: 1, label: "Abertura de Empresa", ENUM: "COMPANY_REGISTER" },
  { value: 2, label: "Alteração de Pacote", ENUM: "PACKAGE" },
  { value: 3, label: "Adição de Empresa", ENUM: "COMPANY" },
];

export default typeRequest;
